<template>
  <section class="compare-section">
    <h6 class="compare-section-title">Operation Mode</h6>
    <div class="compare-mode-legend">
      <span v-for="(modeKey, index) in model.modeKeys" :key="modeKey" class="compare-mode-legend-item">
        <span class="compare-mode-swatch" :style="{ background: colorOf(index) }"></span>
        {{ modeKey }}
      </span>
    </div>
    <div v-for="engine in model.engines" :key="engine.key" class="compare-mode-engine">
      <div class="compare-mode-label">{{ engine.label }}</div>
      <div class="compare-mode-bars">
        <div v-for="side in sides" :key="side" class="compare-mode-line">
          <span class="compare-mode-side" :style="{ background: sideColors[side] }">{{ side.toUpperCase() }}</span>
          <div v-if="engine[side]" class="compare-mode-bar">
            <span
              v-for="mode in engine[side]"
              :key="mode.key"
              class="compare-mode-segment"
              :style="{ width: `${mode.share}%`, background: colorOf(model.modeKeys.indexOf(mode.key)) }"
              :title="segmentTitle(mode)"
            >
              <template v-if="mode.share >= 12">{{ formatNum(mode.share, 0) }}%</template>
            </span>
          </div>
          <span v-else class="compare-mode-empty">N/A</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatNum } from '@/util/number';
import { toDuration } from '@/util/date';
import { SIDE_COLORS } from '@/views/voyage/utils/voyageCompareSeries';
import { OPERATION_MODE_PALETTE } from '@/util/designTokens';

export default {
  name: 'CompareOperationMode',
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sides: ['a', 'b'],
      sideColors: SIDE_COLORS,
    };
  },
  methods: {
    formatNum,
    colorOf(index) {
      return OPERATION_MODE_PALETTE[index % OPERATION_MODE_PALETTE.length];
    },
    segmentTitle(mode) {
      return `${mode.key.toUpperCase()} · ${formatNum(mode.share, 1)}% · ${toDuration(mode.seconds)}`;
    },
  },
};
</script>

<style scoped>
.compare-section {
  padding: 6px 0;
  border-top: 1px solid #eef2f7;
}

.compare-section-title {
  margin: 4px 0;
  font-size: 12.25px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
}

.compare-mode-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  margin-bottom: 6px;
  font-size: 12.25px;
  color: #455a64;
  text-transform: uppercase;
}

.compare-mode-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.compare-mode-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.compare-mode-engine {
  display: grid;
  grid-template-columns: var(--compare-columns);
  gap: 0 12px;
  align-items: center;
  padding: 4px 0;
  font-size: 14px;
}

.compare-mode-label {
  color: #455a64;
}

.compare-mode-bars {
  grid-column: 2 / 4;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.compare-mode-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.compare-mode-side {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
}

.compare-mode-bar {
  flex: 1 1 auto;
  display: flex;
  height: 20px;
  border-radius: 4px;
  overflow: hidden;
  background: #eef2f7;
}

.compare-mode-segment {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.compare-mode-empty {
  color: #adb5bd;
}

@media (max-width: 767.98px) {
  .compare-mode-engine {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }

  .compare-mode-bars {
    grid-column: 1;
  }
}
</style>
